import moment from "moment-timezone"

export const getHourInfo = currentHour => {
  return moment(currentHour).format("h A").split(" ")
}
